import { CodebookModel } from 'app/shared/model/shared.model';

export interface DeliveryOrderViewModel {
  name: string;
  oib: string;
  partyType: string;
  address: string;
  email: string;
}

export interface DeliveryOrderModel {
  noticeBoardDelivery: CodebookModel[];
  publicAuthorities: CodebookModel[][];
}

export const initialDeliveryOrder: DeliveryOrderModel = {
  noticeBoardDelivery: [],
  publicAuthorities: []
};
